import React from "react";
import { cn } from "@gettactic/helpers";
import { Heading } from "@cmp-src/data-display/Heading/Heading";

export interface WizardReviewSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const WizardReviewSection: React.FC<WizardReviewSectionProps> = ({
  title,
  children,
  className
}) => (
  <div className={cn("rounded-lg border border-neutral-200 p-4", className)}>
    <Heading as="h4" className="mb-3">
      {title}
    </Heading>
    <div className="space-y-2">{children}</div>
  </div>
);
